import axios from 'axios'
import {authUrl, apiUrl} from '../../../config/env.js'
axios.defaults.withCredentials = true

export const getTokens = (shainNo, tokenId) => {
  return axios.get(authUrl + '/api/tokens/' + shainNo + '/' + tokenId)
}

export const popAuthList = (shainNo) => {
  return axios.get(apiUrl + '/auth/get/' + shainNo)
}

export const deleteToken = (shainNo, refreshToken) => {
  return axios.post(authUrl + '/api/token/delete', {
    shain_no: shainNo - 0,
    token: refreshToken + ''
  })
}

export const checkAccessToken = (shainNo, token) => {
  return axios.post(authUrl + '/api/accessToken/check', {
    shain_no: shainNo - 0,
    token: token
  })
}

export const checkRefreshToken = (shainNo, token) => {
  return axios.post(authUrl + '/api/refreshToken/check', {
    shain_no: shainNo - 0,
    token: token
  })
}



// WEBPACK FOOTER //
// ./src/api/auth/index.js